import { useThemeContext } from 'contexts/theme';
import ExprealtyCaIcon from 'components/icon/exprealty-ca-icon';
import ExprealtyCaFrIcon from 'components/icon/exprealty-ca-fr-icon';
import ZoocasaUsaIcon from 'components/icon/zoocasa-usa-icon';
import ExpInServiceIcon from 'components//icon/exp-in-service-icon';
import ExpCommercialIcon from 'components/icon/exp-commercial-icon';
import { EXP_COMMERCIAL_TENANT_ID, EXP_IN_SERVICE_TENANT_ID, EXP_REALTY_CA_TENANT_ID, EXP_REALTY_US_TENANT_ID } from '@tenants/types';
import { useLocale } from 'hooks/use-locale';
import { SiteLanguage } from 'types/locales';

type ThemedIconProps = {
  className?: string;
  onClick?: () => void;
};

export default function ThemedIcon({ className, onClick }: ThemedIconProps) {
  const { tenantId } = useThemeContext();
  const { currentLocale } = useLocale(tenantId);
  const isFrenchCanadian = currentLocale === SiteLanguage.FrenchCA;

  switch (tenantId) {
    case EXP_IN_SERVICE_TENANT_ID:
      return <ExpInServiceIcon className={className} onClick={onClick} />;
    case EXP_REALTY_CA_TENANT_ID:
      return isFrenchCanadian 
        ? <ExprealtyCaFrIcon className={className} onClick={onClick} />
        : <ExprealtyCaIcon className={className} onClick={onClick} />;
    case EXP_REALTY_US_TENANT_ID:
      return <ExprealtyCaIcon className={className} onClick={onClick} />;
    case EXP_COMMERCIAL_TENANT_ID:
      return <ExpCommercialIcon className={className} onClick={onClick} />;
    default:
      return <ZoocasaUsaIcon className={className} onClick={onClick} />;
  }
}
